module.exports = __webpack_public_path__ + "img/alana500.54cf6e81.png";